<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="pt20 disflex" style="justify-content: space-between;">
          <a class="logo" href="/"><img src="static/images/logo.png" /></a>
          <div class="disflex" style="justify-content: flex-end;">
            <div class="" @click="getLan('language')">
              <img style="width: 1.4rem" src="../../static/images/en.png" />
            </div>
            <div class="account-top ar" @click="getAcount()" @click.stop>
              <img  style="width: 1.4rem" src="static/images/account-icon2.png" v-if="isShow">
              <img style="width: 1.4rem" src="static/images/account-icon.png" v-else>
            </div>
          </div>
        </div>
        <div class="menu-bg" v-if="isActive">
          <div class="disflex" style="justify-content: space-between;">
            <img style="width: 1.4rem" @click="isActive=false" src="../../static/images/back.png" />
          </div>
          <div class="account ac mt50" @click="getMenu('myAccount')">
            <a class="logo" href="/"><img src="static/images/logo.png" /></a>
            <div class="mt30">
              <img style="width: 10rem" src="static/images/account.png" />
            </div>
            <div class="crfff">{{info.nickname}}</div>
            <div class="crfb7925 mt20">{{$t('ChancesLeft')}}: {{info.score}}</div>
          </div>
          <div class="menu-list ac">
            <div class="" :class="{'active':isShowMenu=='purchaseChances'}" @click="getMenu('purchaseChances')">{{$t('PurchaseChances')}}</div>
            <div class="" :class="{'active':isShowMenu=='faq'}" @click="getMenu('faq')">{{$t('FAQ')}}</div>
            <div class="" :class="{'active':isShowMenu=='history'}" @click="getMenu('history')">{{$t('History')}}</div>
            <div class="" :class="{'active':isShowMenu=='billing'}" @click="getMenu('billing')">{{$t('Billing')}}</div>
            <div class="" :class="{'active':isShowMenu=='guidance'}" @click="getMenu('guidance')">{{$t('Guidance')}}</div>
            <div class="" :class="{'active':isShowMenu=='invitation'}" @click="getMenu('invitation')">{{$t('invitation')}}</div>

<!--            <div class="" :class="{'active':isShowMenu=='UNSUBSCRIBE'}" @click="getMenu('UNSUBSCRIBE')">{{$t('UNSUBSCRIBE')}}</div>-->

          </div>
          <div class="ac">

<!--            <button class="button" style="width: 100%;font-size: 1rem" @click="unSubscribe">{{$t('UNSUBSCRIBE')}}</button>-->
            <button
              class="button"
              style="width: 100%;font-size: 1rem"
              @click="info.sub_status == 3 && info.valid == 'Y' ? logout() : unSubscribe()"
            >
              {{ info.sub_status == 3 && info.valid == 'Y' ? $t('LOGOUT') : $t('UNSUBSCRIBE') }}
            </button>
          </div>
        </div>
    </div>


    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" >
        <div class="alert-modal"  slot="mdBox" >
            <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 2rem;">×</div>
            <div class="information mt100 crfff ac por">
              <div class="fs50">{{$t('language')}}</div>
              <div class="fs26 mt30 cr0062ff">{{$t('languageTips')}} :</div>
                <div class="change-list change-list2 ac">
                  <div class="one"  @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:5rem" :src="isShowLang=='en'?'../../static/images/en.jpg':'../../static/images/en.jpg'" />
                    <span>{{$t('English')}}</span>
                  </div>
                  <div class="one"  @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
                    <img class="dui" src="../../static/images/dui.png">
                    <img style="width:5rem" :src="isShowLang=='bur'?'../../static/images/Cambodia.webp':'../../static/images/Cambodia.webp'" />
                    <span>{{$t('Cambodia')}}</span>
                  </div>
                </div>
              <div class="ac mt50" style="margin-bottom: 2rem">
                <a href="/">
                  <button class="button fw7" @click="reloadPage()">{{$t('change')}}</button>
                </a>

              </div>
            </div>
        </div>
    </Dialog>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }
        },
		methods: {
      getLan(){
        let that = this
        that.$refs.imgDialog.showMaskFun();
      },
      closeTmgDialog(){
        this.$refs.imgDialog.closeMask();
      },

      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          // location.reload()
        }else{
          this.isShowLang = lang
          this.lang = lang
        }
      },
      reloadPage(){
        localStorage.setItem('lang',this.lang)
        location.reload()
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
        if (url == "UNSUBSCRIBE"){
          that.unSubscribe();
        }else {
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
        }

      },
			getAcount(){
				let that =this;
			  this.isActive = true;
        this.getInfo()
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	let that =this;
      	that.$parent.$parent.loadModal(true);
      	that.$api.post('api/user/unsub',null,r =>{
      		that.$parent.$parent.returnCode(r,function(){
      	    that.$parent.$parent.loadModal(false);
            let mobile = localStorage.getItem('mobile')
            localStorage.removeItem('token');
            that.$router.push({path:'/login',query:{mobile:mobile}})
      	  });
      	})
      },
      logout(){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('api/user/logout',null,r =>{
          that.$parent.$parent.returnCode(r,function(){
            that.$parent.$parent.loadModal(false);
            let mobile = localStorage.getItem('mobile')
            localStorage.removeItem('token');
            that.$router.push({path:'/login',query:{mobile:mobile}})
          });
        })
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            that.$parent.$parent.loadModal(false);
          });
        })
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue